require('./RAImageButtonGroup.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

class RAImageButtonGroup extends React.Component {
    render() {
        const { children, extraClass, onChange, selectedValue } = this.props;
        const classes = classNames('ra-image-group', extraClass);
        const clonedChildren = React.Children.map(children, element => {
            const childProps = {
                isChecked: selectedValue === element.props.value,
                onChange,
            };

            return React.cloneElement(element, childProps);
        });

        return <div className={classes}>{clonedChildren}</div>;
    }
}

RAImageButtonGroup.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    extraClass: PropTypes.string,
    onChange: PropTypes.func,
    selectedValue: PropTypes.any,
};

module.exports = RAImageButtonGroup;
